// The Printful catalog (`fetchProducts`) is called from the root route's
// loader, which reruns on every full page load - a hard refresh, or
// navigating straight to a URL like /shop - since that reinitializes the
// app and Redux store from scratch. The catalog doesn't change often, so
// we cache it in sessionStorage for a few minutes to avoid re-hitting
// Printful on every reload within the same browsing session.
const PRODUCTS_CACHE_KEY = "printful-products-cache";
const PRODUCTS_CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes

export const getCachedProducts = () => {
  try {
    const cached = sessionStorage.getItem(PRODUCTS_CACHE_KEY);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp > PRODUCTS_CACHE_TTL_MS) return null;

    return data;
  } catch {
    // Private browsing, corrupted entry, storage disabled, etc. - just
    // fall back to a normal network fetch.
    return null;
  }
};

export const setCachedProducts = (data) => {
  try {
    sessionStorage.setItem(
      PRODUCTS_CACHE_KEY,
      JSON.stringify({ data, timestamp: Date.now() }),
    );
  } catch {
    // Ignore storage errors (quota exceeded, private browsing, etc.) -
    // caching is a nice-to-have, not a requirement.
  }
};
